/**
 * User Setting autohandler.
 *
 * Usage:
 *
 *  data-sw-user-setting="<setting name>"
 *  data-sw-user-setting-value="<value>"
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

$(document).ready(function() {
  $('body').on('click', '[data-sw-user-setting]', function() {
    var $el = $(this);
    var elData = $el.data();

    sw.setSetting(elData.swUserSetting, elData.swUserSettingValue);
  });
});
